import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform();

export const initializeApp = async () => {
    if (isNative) {
        try {
            // Importações dinâmicas para evitar erros no web
            const { StatusBar, Style } = await import('@capacitor/status-bar');
            const { SplashScreen } = await import('@capacitor/splash-screen');

            // Configurar status bar
            if (platform === 'android') {
                await StatusBar.setStyle({ style: Style.Dark });
                await StatusBar.setBackgroundColor({ color: '#00000000' }); // Transparente
                await StatusBar.setOverlaysWebView({ overlay: true });
            } else if (platform === 'ios') {
                await StatusBar.setStyle({ style: Style.Light });
            }

            // Esconder splash screen após 2 segundos
            setTimeout(async () => {
                await SplashScreen.hide();
            }, 2000);
        } catch (error) {
            console.warn('Erro ao inicializar recursos nativos:', error);
        }
    }
};

// Verificar se está rodando em modo nativo
export const checkPlatform = () => {
    return {
        isNative,
        platform,
        isAndroid: platform === 'android',
        isIOS: platform === 'ios',
        isWeb: platform === 'web'
    };
};
